module.exports = require("@makemydeal/dr-activities-lead-form");